import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_195_vendor_bill_wise_release_add: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Bill Release",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "vendor_bill_wise_release",
        TableName: "vendor_bill_wise_release",
        Plugins: [{ type: "api", module: "all" }],
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Bill release details",
            BindValue: "con_vendor_bill_wise_release_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_vendor",
                label: "Vendor name",
                placeholder: "Select vendor",
                required: true,
                lookupName: "supplier_with_due_from_transaction",
                options: [],
                Json_Attribute: "vendor_id",
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Vendor name is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_document_no",
                label: "Document No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "document_no",
                disabled: true,
                BindValue: "document_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_document_type",
                label: "Document type",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "document_type",
                disabled: true,
                BindValue: "document_type",
                defaultValue: "purchase_bill",
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "vendor_bill_wise_release_purchase",
            label: "Purchase release details",
            vendorBillWiseReleaseInvoiceMode: true,
            tableName: "vendor_bill_wise_release_purchase_split",
            lookupName: "vendor_purchase_details_paid",
            parentField: "drp_vendor",
            DisableAddNewRow: true,
            enableDeleteAction: true,
            BindValue: "vendor_bill_wise_release_purchase_split",
            childControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchase_no",
                label: "Purchase No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                Json_Attribute: "purchase_no",
                disabled: true,
                BindValue: "txt_purchase_no",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_due_amount",
                label: "Due amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "due_amount",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_due_amount",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount_paid",
                label: "Paid amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount_paid",
                defaultValue: "0",
                disabled: true,
                BindValue: "txt_amount_paid",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_release_amount",
                label: "Release amount",
                placeholder: "",
                required: true,
                inputType: InputType.NUMBER,
                Json_Attribute: "amount",
                defaultValue: "0",
                BindValue: "txt_release_amount",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_release_amount] > 0",
                    message: "Release amount must be greater than zero",
                  },
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[txt_release_amount] <= [txt_amount_paid]",
                    message: "Release amount cannot exceed paid amount",
                  },
                ],
              },
            ],
            FooterControls: [
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_release_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
                validation: [
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[net_amount] > 0",
                    message: "Amount must be greater than zero",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
